import React from 'react';

import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const IconLumiOutlined: React.FC<SvgIconProps> = (props) => (
  <SvgIcon viewBox="0 0 16 16" {...props}>
    <defs>
      <linearGradient
        id="paint0_linear_14091_521"
        x1="0.666504"
        y1="0.666664"
        x2="15.8577"
        y2="0.892012"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7F14EE" />
        <stop offset="0.515" stopColor="#D62EA9" />
        <stop offset="1" stopColor="#F36C23" />
      </linearGradient>
    </defs>
    <path
      d="M12.6665 6L13.4998 4.16666L15.3332 3.33333L13.4998 2.5L12.6665 0.666664L11.8332 2.5L9.99984 3.33333L11.8332 4.16666L12.6665 6Z"
      fill="url(#paint0_linear_14091_521)"
    />
    <path
      d="M12.6665 10L11.8332 11.8333L9.99984 12.6667L11.8332 13.5L12.6665 15.3333L13.4998 13.5L15.3332 12.6667L13.4998 11.8333L12.6665 10Z"
      fill="url(#paint0_linear_14091_521)"
    />
    <path
      d="M7.6665 6.33333L5.99984 2.66666L4.33317 6.33333L0.666504 8L4.33317 9.66666L5.99984 13.3333L7.6665 9.66666L11.3332 8L7.6665 6.33333ZM6.65984 8.66L5.99984 10.1133L5.33984 8.66L3.8865 8L5.33984 7.34L5.99984 5.88666L6.65984 7.34L8.11317 8L6.65984 8.66Z"
      fill="url(#paint0_linear_14091_521)"
    />
  </SvgIcon>
);

export default IconLumiOutlined;
